import toLower from 'ramda/src/toLower'
import CognitoUser from 'amazon-cognito-identity-js/lib/CognitoUser'
import AuthenticationDetails from 'amazon-cognito-identity-js/lib/AuthenticationDetails'

import userPool from 'root/src/client/logic/auth/util/userPool'

import determineAuth from 'root/src/client/logic/auth/thunks/determineAuth'

import afterLoginRouteSelector from 'root/src/client/logic/auth/util/afterLoginRouteSelector'
import setSession from 'root/src/client/logic/auth/util/setSession'
import authSelector from 'root/src/client/logic/auth/util/authSelector'
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'

import {
	TRANSFER_ACCOUNT_ROUTE_ID,
} from 'root/src/shared/descriptions/routes/routeIds'
import { authApi } from 'root/src/shared/util/authApi'
import cognitoErrorHandler from 'root/src/client/logic/auth/util/cognitoErrorHandler'
import displayModal from 'root/src/client/logic/modal/actions/displayModal'

const authApiLoginHandler = ({ email, password }) => async (resolve, reject) => {
	try {
		const { error: err, ...body } = await authApi.signIn({
			email,
			password,
		})

		if (err) {
			return reject(err)
		}

		return resolve(body)
	} catch (e) {
		return reject(e)
	}
}

const login = ({ email, password }) => (dispatch, getState) => new Promise(
	async (resolve, reject) => {
		const correctedEmail = toLower(email)
		// if error - login with cognito and try again
		try {
			const res = await authApi.signIn({ email, password })
			return resolve(res)
		} catch (e) {
			const authenticationDetails = new AuthenticationDetails({
				Username: correctedEmail,
				Password: password,
			})
			const cognitoUser = new CognitoUser({
				Username: correctedEmail,
				Pool: userPool,
			})
			return cognitoUser.authenticateUser(authenticationDetails, {
				onSuccess: ({ idToken }) => pushRouteClient(
					{ routeId: TRANSFER_ACCOUNT_ROUTE_ID, query: { token: idToken.jwtToken } },
				),
				onFailure: cognitoErrorHandler(
					resolve,
					reject,
					async () => authApiLoginHandler({ email, password })(resolve, reject),
				),
				newPasswordRequired: () => cognitoUser
					.completeNewPasswordChallenge(password, {}, {
						onSuccess: () => login({ email, password })(dispatch, getState),
					}),
			})
		}
	},
).then(async (session) => {
	setSession(authSelector(session))
	await dispatch(determineAuth())
	dispatch(displayModal(undefined))
	const afterLoginRoute = await afterLoginRouteSelector({
		dispatch,
		getState,
	})
	return pushRouteClient(afterLoginRoute)
})

export default login
